import { useDetailApi } from "../../../swr";
import { partnersService } from "../../api_client";
import type { PartnerOverviewStatsDto } from "../../../api";

export function usePartnerStats() {
  const { data } = useDetailApi<PartnerOverviewStatsDto>({
    key: "/partners/stats",
    serviceMethod: () => partnersService.getOverviewStats(),
  });

  return {
    total: data?.totalPartners,
    sellers: data?.sellers,
    buyers: data?.buyers,
  };
}
